module.exports = __webpack_public_path__ + "img/facial_hair_full_beard_thin_rect.a51ffd4d.png";